// extracted by mini-css-extract-plugin
export default {"addUser":"AddUser_addUser__QK2CE"};